const troubles = [
  {
    title: "パンプスが脱げる",
    subtitle: "かかとが抜けて、歩くたびが不安",
    description: "かかとが浮く、前に滑る——それはサイズではなく、足の形に原因があります。",
    tags: ["かかと抜け", "前滑り", "サイズ感"],
    image: "https://readdy.ai/api/search-image?query=elegant%20woman%20wearing%20beige%20classic%20pumps%20walking%20on%20city%20street%20natural%20gait%20confident%20posture%20warm%20neutral%20background%20fashion%20magazine%20style%2030s%20japanese%20woman&width=600&height=400&seq=trouble1&orientation=landscape",
    href: "#",
  },
  {
    title: "細幅・幅狭で困る",
    subtitle: "AA・A幅の足、選択肢が少なすぎる",
    description: "幅が細いと靴の中で足が泳ぎやすい。細幅専用のフィッティングで解決できます。",
    tags: ["AA幅", "A幅", "スリム"],
    image: "https://readdy.ai/api/search-image?query=close-up%20of%20slender%20elegant%20female%20feet%20in%20slim%20pointed%20toe%20heels%20beige%20shoes%20sitting%20pose%20soft%20warm%20lighting%20minimalist%20aesthetic%20clean%20background&width=600&height=400&seq=trouble2&orientation=landscape",
    href: "#",
  },
  {
    title: "小さいサイズが見つからない",
    subtitle: "22cm以下、探しても選べる靴がない",
    description: "小さい足でも、おしゃれな選択肢は必ずあります。サイズ展開を広く揃えています。",
    tags: ["22cm以下", "小さいサイズ", "豊富な展開"],
    image: "https://readdy.ai/api/search-image?query=japanese%20woman%20sitting%20trying%20on%20elegant%20heels%20in%20boutique%20store%20warm%20interior%20lighting%20wooden%20floor%20refined%20atmosphere%20soft%20focus%20background&width=600&height=400&seq=trouble3&orientation=landscape",
    href: "#",
  },
  {
    title: "大きいサイズでも綺麗に",
    subtitle: "25cm以上でもスタイリッシュに履きたい",
    description: "大きめの足をコンプレックスにしなくていい。デザイン性と機能を両立した靴があります。",
    tags: ["25cm以上", "大きいサイズ", "スタイリッシュ"],
    image: "https://readdy.ai/api/search-image?query=stylish%20woman%20long%20legs%20wearing%20chic%20pointed%20heels%20walking%20on%20clean%20floor%20sophisticated%20fashion%20editorial%20look%20warm%20tones%20natural%20light%20japanese%20style&width=600&height=400&seq=trouble4&orientation=landscape",
    href: "#",
  },
  {
    title: "就活パンプスがつらい",
    subtitle: "一日中履いても、疲れにくく見た目も正統派",
    description: "痛みを我慢しながら就活しなくていい。フォーマルで疲れにくい一足を見つけましょう。",
    tags: ["就活", "長時間", "フォーマル"],
    image: "https://readdy.ai/api/search-image?query=professional%20japanese%20young%20woman%20in%20business%20suit%20standing%20with%20black%20classic%20pumps%20office%20corridor%20confident%20expression%20clean%20modern%20interior&width=600&height=400&seq=trouble5&orientation=landscape",
    href: "#",
  },
  {
    title: "外反母趾でもおしゃれに",
    subtitle: "痛みを気にせず、好きなデザインを選びたい",
    description: "外反母趾だからといって、おしゃれをあきらめない。フィッティングと調整で変わります。",
    tags: ["外反母趾", "幅広", "調整可能"],
    image: "https://readdy.ai/api/search-image?query=woman%20feet%20wearing%20beautiful%20wide-toe-box%20elegant%20pumps%20comfortable%20fit%20soft%20warm%20indoor%20lighting%20wooden%20parquet%20floor%20lifestyle%20minimal%20aesthetic&width=600&height=400&seq=trouble6&orientation=landscape",
    href: "#",
  },
];

export default function TroubleCardsSection() {
  return (
    <section id="troubles" className="bg-white py-20 md:py-28" style={{ scrollMarginTop: '72px' }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-14">
          <p
            className="text-[#B8895A] text-xs tracking-widest mb-4 uppercase"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            Find Your Fit
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              お悩みから、<br />
              自分に合う靴を探す。
            </h2>
            <p
              className="text-[#78716C] text-sm leading-loose max-w-xs"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              あなたの「あるある」が、<br className="hidden md:block" />ぴったりの一足への入口になります。
            </p>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {troubles.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="group bg-white rounded-2xl overflow-hidden border border-[#F0EBE3] hover:border-[#B8895A]/50 transition-all duration-300 cursor-pointer block"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
              </div>

              {/* Card body */}
              <div className="p-6">
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-[#F5F0EA] text-[#B8895A] text-xs px-2.5 py-1 rounded-full whitespace-nowrap"
                      style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <h3
                  className="text-[#1C1917] text-base font-bold mb-1.5 leading-snug group-hover:text-[#B8895A] transition-colors"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-[#78716C] text-xs leading-relaxed mb-4"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {item.description}
                </p>

                <div className="flex items-center gap-1.5 text-[#B8895A] text-xs font-medium">
                  <span style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    この悩みを解決する
                  </span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p
            className="text-[#78716C] text-sm mb-5"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            当てはまるものが複数ある方は、スタッフへ相談いただくのがおすすめです。
          </p>
          <a
            href="#"
            className="inline-flex items-center gap-2 border border-[#B8895A] text-[#B8895A] hover:bg-[#B8895A] hover:text-white transition-colors text-sm px-8 py-3 rounded-full cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-chat-3-line" />
            </div>
            LINEで無料相談する
          </a>
        </div>
      </div>
    </section>
  );
}